<template>
    <div>        
        <div class="p-col-12">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Empresa</label>
                    <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                        @change="listarCentrosCustos"/>
                </div>                      
            </div>
            <div class="p-fluid p-formgrid p-grid">              
                <div class="p-field p-col-12 p-md-6">
                    <label>Escala de horários</label>               
                    <Dropdown v-model.number="idContratoSelecionado" :options="contratos" optionLabel="descricao" optionValue="id" placeholder="Selecione"/>
                </div>  
                <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="buscarFuncionariosPorContrato"/>
                    </div>    
                <div class="p-field p-col-12 p-md-6">
                    <label>Centro de custo</label>               
                    <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                        dataKey="keyRefId" :filter="true" :showClear="true"/>
                </div>    
                <div class="p-field p-col-0">
                    <label style="color:#ffffff">.</label>  
                    <Button label="Buscar" icon="pi pi-search" @click="buscarFuncionariosPorCentroCusto"/>
                </div>                               
            </div>
            <div class="p-fluid p-formgrid p-grid"> 
                <div class="p-field p-col-12 p-md-12">
                    <label style="color: #ffffff">.</label>
                    <div class="p-inputgroup">
                        <InputText v-model.trim="crachaNome" 
                        @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                        @keyup.enter="buscarFuncionariosCrachaNome" 
                        placeholder="crachá/pis/cpf/nome"/>
                        <Button label="Buscar" @click="buscarFuncionariosCrachaNome"/>                    
                    </div>
                </div>                      
            </div>            
        </div>
        <PickList v-model="funcionarios" listStyle="height:300px" dataKey="id">
            <template #sourceHeader>
                Funcionários Disponíveis
            </template>
            <template #targetHeader>
                Funcionários Selecionados
            </template>
            <template #item="slotProps">
               <div>
                   {{slotProps.item.cracha}} {{slotProps.item.nome}}
               </div>
           </template> 
        </PickList>
    </div>
</template>

<script>
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import CentroCustoService from '@/service/CentroCustoService';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    centroCustoService: null,
    funcionarioPesquisaService: null,  
    data() {
        return {        
            ativo: true,
            crachaNome: '',           
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            idContratoSelecionado: null,  
            cnpjs:[],
            contratos: [],            
            centrosCustos: [],
            funcionarios: null
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),  
        ...mapActions('sessao', ['atualizarCacheEmpresa']),    
        buscarFuncionariosPorCentroCusto(){
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                ativo: true,
                idsCentrosCustos: idsCentrosCustos,                
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.funcionarioPesquisaService.buscarFuncionarios(requisicao)
				.then(resp => {                                          
                    this.funcionarios = [resp.data, []];                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },  
        buscarFuncionariosPorContrato(){
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            if(!this.idContratoSelecionado 
                || this.idContratoSelecionado == null 
                || (typeof this.idContratoSelecionado === undefined)) {
                exibirMensagemSis(this, 'Selecione uma escala de horário', true);
                return;
            }
            let idsCentrosCustos = [];
            this.centrosCustos.forEach(ct => {
                if(ct.id != null) {
                    idsCentrosCustos.push(ct.id);
                }
            });
            let requisicao = {
                idsCentrosCustos: idsCentrosCustos,
                idContrato: this.idContratoSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.funcionarioPesquisaService.buscarFuncionariosContrato(requisicao)
				.then(resp => {                                          
                    this.funcionarios = [resp.data, []];                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },        
        buscarFuncionariosCrachaNome(){
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            if(this.crachaNome == '') {
                this.funcionarios = null;
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }                    
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                ativo: true,
                crachaNome: this.crachaNome,
                idsCentrosCustos: idsCentrosCustos,               
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.funcionarioPesquisaService.buscarFuncionariosCrachaNome(requisicao)
				.then(resp => {                                          
                    this.funcionarios = [resp.data, []];                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        listarContratosCnpjs() {
            let usuarioRequisicao = {...this.getDadosRequisicao()};
            this.funcionarioPesquisaService.listarContratos(usuarioRequisicao)
            .then(resp => {			
                this.contratos = resp.data;
            })
            .catch(erro => {exibirMensagem(this, erro)});
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            centroCusto['keyRefId'] = Date.now();
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {    
                // Cache dados      
                cacheEmpresa.centrosCustos = [];  
                let dataKey = 1;               
                resp.data.forEach(ct => {
                    ct['keyRefId'] = dataKey++;
                    cacheEmpresa.centrosCustos.push({...ct});
                });           
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                centroCusto['keyRefId'] = Date.now();
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);  
                this.atualizarCacheEmpresa(cacheEmpresa);                   
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        getFiltro() {
            let dados = {      
                cnpj: {},
                funcionarios: [],
            };
            if(this.funcionarios == null) {
               return dados;
            }        
            let cnpj = null;
            this.cnpjs.forEach(item => {
                if(item.id == this.idCnpjSelecionado) {
                    cnpj = item;
                }
            });
            dados.cnpj = cnpj;
            dados.funcionarios = this.funcionarios[1];
            return dados;
        },
        getCnpjs() {
            return [...this.cnpjs];
        },
        limparSelecionados() {
            this.funcionarios = null;
        }
    },
    created() {
        this.centroCustoService = new CentroCustoService();
        this.funcionarioPesquisaService = new FuncionarioPesquisaService();       
    },
    mounted() {
        this.listarContratosCnpjs();
    }
}
</script>

<style>

</style>